import Action from "../base/action";
import LoadTimeline from "../base/load-timeline";
import {applyPruneToTimelineItem} from "../base/training-literals";

class BranchSelect extends Action {
    until;
    model;
    defaultAction;
    timelineMap;
    _stopper;

    constructor(props) {
        super(props);
        this.until = props.until;
        this.model = props.model;
        this.defaultAction = props.defaultAction && new LoadTimeline(props.defaultAction);
        this.pickAction = Object.fromEntries(props.timelineMap.map(item => {
            const timelineItem = applyPruneToTimelineItem(item, props.prune);
            return [item.branch.id, new LoadTimeline(timelineItem)];
        }));
        this._stopper = () => {
        };
    }

    async execute(eventLoop) {
        let self = this;
        this._stopper = activateBranchSelect();
        setTimeout(this._stopper, self.until - self.startTime);

        function activateBranchSelect() {
            VR.canvas.addEventListener('branch_selected', handleBranchSelected);
            return () => VR.canvas.removeEventListener('branch_selected', handleBranchSelected);
        }

        async function handleBranchSelected(event) {
            const branchData = event.detail.branchData;
            const modelId = branchData?.modelId;
            let branchNode = MeshHierarchyViewFeatureData.getDataFromBranchID(branchData?.branchID);
            let done = false;
            while (true) {
                const nextAction = getNextTimeline(modelId, branchNode?.branchID);
                if (nextAction) {
                    done = true;
                    self._stopper();
                    await nextAction.execute(eventLoop);
                    break;
                }

                branchNode = branchNode?.parent;
                if (branchNode?.branchID === "-1") {
                    break;
                }
            }

            if (!done && self.defaultAction && (self.defaultAction.timelines.length || (self.defaultAction.events && self.defaultAction.events.length))) {
                self._stopper();
                await self.defaultAction.execute(eventLoop);
            }
        }

        function getNextTimeline(modelId, branchId) {
            if (!self.model || eventLoop.training.resources[self.model.id]?.resourceId === modelId ||
                (eventLoop.training.resources[self.model.id]?.type === ResourceTypeEnum.HELPER_OBJECT && eventLoop.training.resources[self.model.id]?.id === modelId)) {
                if (self.pickAction[branchId]) {
                    return self.pickAction[branchId];
                }
            }
        }
    }

    async stop() {
        this._stopper();
    }
}

export default BranchSelect;
